import { useBreakpoint } from 'src/hooks';
import { UnreadCountButton } from 'src/components/UnreadCountButton';
import { ThreadView } from 'src/components/FlatAppearance/components/ThreadView';
import styles from './MultiConversationsPanel.module.scss';

interface MultiConversationsPanelProps {
  startSpeechRecognizing: (defaultValue?: string) => Promise<void>;
  stopSpeechRecognizing: () => Promise<void>;
}

export const MultiConversationsPanel = ({
  startSpeechRecognizing,
  stopSpeechRecognizing,
}: MultiConversationsPanelProps) => {
  const { isDesktopAndUp } = useBreakpoint();

  return (
    <div className={styles.root}>
      {isDesktopAndUp && <UnreadCountButton />}

      <ThreadView
        startSpeechRecognizing={startSpeechRecognizing}
        stopSpeechRecognizing={stopSpeechRecognizing}
      />
    </div>
  );
};
